import cloneDeep from 'lodash/cloneDeep';
import chartUtils from '../../../utils/chart-utils';

var irisHost = function irisHost() {
	// Render Iris host widget
	var renderWidget = function renderWidget(widgetConfig) {
		var ContainerId = widgetConfig.ContainerId,
		    Height = widgetConfig.Height,
		    IrisConfig = widgetConfig.IrisConfig,
		    Width = widgetConfig.Width;


		var el = document.querySelector('#' + ContainerId);
		var height = Number(chartUtils.replaceAll(Height, '\x01', ''));
		var width = Number(chartUtils.replaceAll(Width, '\x01', ''));
		var targetUrl = IrisConfig.Url;

		var urlContainer = document.createElement('div');
		urlContainer.setAttribute('class', 'urlContainer');
		el.appendChild(urlContainer);

		if ($('#ContainerId .urlContainer > p').length) {
			$('#ContainerId .urlContainer > p').hide();
		}

		var invalidUrlMessage = '<p style="text-align:center">Please enter valid URL!</p>';
		var frameContainer = document.createElement('object');
		frameContainer.setAttribute('id', 'frameContainer-' + ContainerId);
		urlContainer.appendChild(frameContainer);
		var container = document.getElementById('frameContainer-' + ContainerId);
		container.setAttribute('style', 'width:' + width + 'px;height:' + height + 'px');
		container.setAttribute('data', targetUrl);

		setTimeout(function () {
			if ($('#frameContainer-' + ContainerId)[0].offsetHeight === 0 && $('#frameContainer-' + ContainerId)[0].offsetWidth === 0) {
				$('#' + ContainerId + ' .urlContainer')[0].innerHTML = invalidUrlMessage;
				$('#' + ContainerId + ' .urlContainer > p').show();
			}
		}, 500);
	};

	// Initiate rendering for a widget
	var initiateWidgetRendering = function initiateWidgetRendering(widgetConfig) {
		renderWidget(cloneDeep(widgetConfig));
	};
	return {
		renderWidget: renderWidget,
		initiateWidgetRendering: initiateWidgetRendering
	};
};

export default irisHost();